// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3zyGT","colMaxWidth":"Table_colMaxWidth__1xLpM"};